const API_PATH = "/api"
export const API_ROUTES = {
  BOOK: {
    BASE: "/book",
    FILTER: "/filter",
    BUNDLE: "/bundle",
    NOTIFIES: "/bundle_notifies",
    MESSAGE_THEMES: "/messagethemes",
    BUNDLE_SYNC: "/bundle_sync",
    SAVED_TOURS: "/saved_tours",
    TOUR_SHARE_TEMPLATES: "/tour_share_templates",
    ADMIN_EXTENSION_TOKENS: "/admin_extension_tokens",
    ADMIN_SAVED_TOURS: "/admin_saved_tours",
  },
  SHARED_TOURS: {
    BASE: "/shared_tours",
    REQUEST_CONSULTATION: "request_consultation",
  },
  FILTERS: {
    BASE: "/filters",
  },
  TERMINALS: {
    BASE: API_PATH,
    TERMINALS: "/terminals",
  },
  TRANSPORT: {
    BASE: "/transport",
    COMPANIES: "/companies",
  },

  ADMIN: {
    BASE: "/admin",
    DEPARTMENTS: "/departaments",
    STATES: "/states",
    HOTELS: "/hotels",
  },
  TRANSFER: {
    BASE: "/transfer",
    SEARCH: "/search",
    DEPARTMENTS: "/destinations",
  },
  API: {
    BASE: "/api",
    USER_SETTINGS: "/user_settings",
  },
}
